import { apiFetch } from "@/lib/api";
import { hubDevCoordinatorApiBase } from "@/lib/devCoordinatorOrigin";

export const WORKSPACE_AVATAR_SYNC_OPERATOR_EMAIL = "e.edwards@smartgridsolutions.com";

export interface WorkspaceAvatarSyncStatus {
  operatorEligible: boolean;
  oauthConfigured: boolean;
  workspaceConnected: boolean;
  avatarSyncPendingCount: number;
  avatarSyncPending: Array<{ userId: string; email: string; displayName: string | null }>;
  avatarMissingAfterSyncCount: number;
}

export function fetchWorkspaceAvatarSyncStatus(): Promise<WorkspaceAvatarSyncStatus> {
  return apiFetch<WorkspaceAvatarSyncStatus>("/api/user-admin/workspace-avatar-sync/status");
}

export function startWorkspaceOAuth(input: {
  returnTo?: string;
  uiOrigin?: string;
}): Promise<{ authorizeUrl: string; expiresAt: string }> {
  const base = hubDevCoordinatorApiBase();
  return apiFetch(`${base}/api/user-admin/workspace-oauth/start`, {
    method: "POST",
    body: input,
  });
}

export function syncAllWorkspaceAvatars(): Promise<{
  ok: boolean;
  updatedCount: number;
  errorCount: number;
}> {
  return apiFetch("/api/user-admin/sync-workspace-avatars", { method: "POST" });
}

export function syncSelectedWorkspaceAvatars(userIds: string[]): Promise<{
  ok: boolean;
  updatedCount: number;
  errorCount: number;
}> {
  return apiFetch("/api/user-admin/sync-workspace-avatars/selected", {
    method: "POST",
    body: { userIds },
  });
}
